import { Icon, type IconPropsWithoutChildren } from "@components/icon"
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural"

export const AvatarIcon = (props: IconPropsWithoutChildren) => {
	return (
		<Icon {...props}>
			<FaceRetouchingNaturalIcon fontSize="inherit" />
		</Icon>
	)
}
